import { Application } from 'application/Shared/types/application';
import { TenantApp } from 'application/Shared/types/tenantApp';
import { User } from 'application/Shared/types/user';

/**
 * Groups users from tenant applications and returns users with their associated applications.
 * Transforms app-centric data structure to user-centric structure.
 *
 * @param data - Array of TenantApp objects containing users and applications
 * @returns Array of User objects with their associated applications
 */
export function groupUsersFromTenantApps({
    data
}: {
    data: TenantApp[];
}): User[] {
    const result = Object.values(
        data.reduce((acc: Record<string, User>, tenantApp: TenantApp) => {
            if (tenantApp.users) {
                tenantApp.users.forEach((userApp) => {
                    const { platformUserId, user } = userApp;
                    if (!acc[platformUserId]) {
                        acc[platformUserId] = {
                            ...user,
                            applications: [],
                            id: platformUserId
                        };
                    }
                    acc[platformUserId]?.applications?.push(
                        tenantApp.application as Application
                    );
                });
            }
            return acc;
        }, {})
    );
    return result;
}
